/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable */
import React, { useState, useEffect } from 'react'
import DesktopHeader from 'AccountsDesktopComponents/Header'
import Train from 'SVGPath/train.svg'
import Hotel from 'SVGPath/hotel.svg'
import Flight from 'SVGPath/flight.svg'
import Tick from 'SVGPath/tick.svg'
import { readCookie, getLanguageMeta } from 'AccountsUtils'
import { Helmet } from 'react-helmet'
import { ViewContainer } from '../UnifiedLogin'
import { checkMobileDevice, checkUserLogin } from '../../utils/validator'

import useModal from './useModal'
import {
  getAbTestConfigPWA,
  getAuthenticated,
  supportByTripId
} from '../../pages/Trips/trips.helper'
import HotelBookImage from '../../images/hotelbooking.png'

import { Login } from '../Login'
import Footer from '../../components/Desktop/Footer'
import { initializeClevertap } from '../../utils'
import { isInFlyinDomain } from 'AccountsUtils'
import PageLoader from 'Lib/Pageloader'
import './index.scss'
import { deviceId } from '../../deviceIdUtils'

const SupportDesktop = () => {
  const { isShowing, toggle } = useModal()
  const [tripId, setTripId] = useState(null)
  const [page, setPageName] = useState(null)
  const [otp, setOTP] = useState(null)
  const [otpReceived, setOTPReceived] = useState(false)
  const [otpReceivedErr, setOTPReceivedErr] = useState(false)
  const [snackMsg, setSnackMsg] = useState(null)
  const timerOn = true
  const { locale } = getLanguageMeta()
  const showUnifiedLogin = locale === 'IN'
  const [visibilityCSS, setVisibilityCSS] = useState(true)
  const [invalidAccount, setInvalidAccount] = useState(false)
  const [deletedMsg, setDeletedMsg] = useState(null)
  const [abLogin, setAbLogin] = useState('a')
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    deviceId()
  }, [])
  useEffect(() => {
    initializeClevertap()
    setTimeout(() => {
      setVisibilityCSS(false)
    }, 500)

    async function getAbData() {
      const response = await getAbTestConfigPWA()
      const { status: responseStatus, data: responseData } = response || {}
      if (response && responseStatus === 200 && responseData) {
        if (responseData?.login_init === 'a') {
          setAbLogin('a')
        } else {
          setAbLogin('b')
        }
      }
    }

    const deleteCookie = name => {
      document.cookie =
        name +
        '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=qa2.cleartrip.ae'
      document.cookie =
        name +
        '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.cleartrip.ae'
      document.cookie =
        name +
        '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=cleartrip.ae'
      document.cookie =
        name +
        '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=qa2.cleartrip.ae'
    }

    getAbData()

    if (checkMobileDevice()) {
      window.location.href = '/m/support'
    } else {
      //  <PageLoader title="Fetching Trip Details" message="Please wait while we load your trip details." />
      if (checkUserLogin()) {
        const isuserLoggein = checkUserLogin()
        console.log('checck', isuserLoggein)
        const getAuthenticatedApiResponse = async () => {
          setLoader(true)
          const response = await getAuthenticated()
          const { status, error } = response
          if (status === 200) {
            window.location.href = isInFlyinDomain()
              ? '/accounts/trips?chnl=Fly'
              : '/accounts/trips'
            setLoader(false)
          } else if (error?.response?.status === 401 && status !== 200) {
            deleteCookie('userid')
            window.localStorage.removeItem('ON_LOGIN_PUSH')
            window.location.href = '/signout'
            setLoader(false)
          }
        }
        getAuthenticatedApiResponse()
      }
    }
  }, [])

  const textHandler = (e, name) => {
    if (name === 'tripId') {
      setTripId(e.target.value)
    }
    if (name === 'otp') {
      setOTP(e.target.value)
    }
  }

  const resetHandler = e => {
    setTripId(null)
    setOTP(null)
    setOTPReceived(false)
    setSnackMsg(null)
    setOTPReceivedErr(false)
    setOTPReceived(false)
    setDeletedMsg(null)
    setInvalidAccount(false)
  }

  const handleIsShowing = () => {
    setPageName('SIGNIN')
    toggle()
  }

  const timer = remaining => {
    let m = Math.floor(remaining / 60)
    let s = remaining % 60
    m = m < 10 ? `0${m}` : m
    s = s < 10 ? `0${s}` : s
    if (document.getElementById('timer')) {
      document.getElementById('timer').innerHTML = `${m}:${s}`
    }
    remaining -= 1

    if (remaining >= 0 && timerOn) {
      setTimeout(() => {
        timer(remaining)
      }, 1000)
      return
    }
    if (timerOn) {
      if (document.getElementById('timer')) {
        document.getElementById('timer').innerHTML = 'Resend OTP'
      }
    }
  }

  const btnHandler = (e, action) => {
    if (
      action.toLowerCase() === 'get otp' ||
      (action.toLowerCase() === 'resend otp' &&
        document.getElementById('timer') &&
        document.getElementById('timer').innerHTML.toLowerCase() ===
          'resend otp')
    ) {
      setSnackMsg(null)
      setOTP(null)
      supportByTripId(tripId).then(resp => {
        if (
          resp &&
          resp.status === 200 &&
          resp.smsResponse.status.toLowerCase() === 'success'
        ) {
          timer(60)
          setOTPReceived(true)
          setOTPReceivedErr(false)
          setDeletedMsg(null)
          setInvalidAccount(false)
          setSnackMsg(
            'OTP has been sent to your mobile number, Email and will expire in 3 mins.'
          )
        } else if (resp && resp.status === 404) {
          setOTPReceived(false)
          setOTPReceivedErr(true)
          setSnackMsg('Please enter a valid Trip Id to get the OTP')
          setDeletedMsg(null)
          setInvalidAccount(false)
        } else if (resp && resp.status === 401) {
          setOTPReceived(false)
          setOTPReceivedErr(true)
          setSnackMsg('OTP request limit exceeded. Please try after sometimes')
        } else if (
          resp &&
          resp.status === 400 &&
          resp.data &&
          resp.data.message === 'DELETED_USER'
        ) {
          setSnackMsg(null)
          setOTPReceivedErr(false)
          setInvalidAccount(true)
          setDeletedMsg(
            'Please check the email associated with Cleartrip for trip details'
          )
        }
      })
    } else if (action.toLowerCase() === 'fetch trip') {
      supportByTripId(tripId, otp).then(resp => {
        if (
          resp &&
          resp.status === 200 &&
          resp.message.toLowerCase() === 'verified'
        ) {
          window.location.href = `/accounts/trips/${tripId}`
        } else if (resp.status === 401) {
          setOTPReceivedErr(true)
          setSnackMsg(
            'You exceeded the OTP validation limit. Please try again in 10 minutes.'
          )
          setDeletedMsg(null)
          setInvalidAccount(false)
        } else if (resp.status === 404) {
          setOTPReceivedErr(true)
          setSnackMsg(
            'Incorrect OTP entry. Please try again, or tap "Resend OTP" for a new OTP'
          )
          setDeletedMsg(null)
          setInvalidAccount(false)
        } else if (resp.status === 500) {
          setSnackMsg('Something went wrong. Please Try Again')
          setDeletedMsg(null)
          setInvalidAccount(false)
        }
      })
    }
  }

  const signHandle = e => {
    setPageName('SIGNIN')
    toggle()
  }

  window.androidData = window?.MobileApp
    ? JSON.parse(window?.MobileApp?.getAppSpecificData())
    : {}
  return (
    <React.Fragment>
      {checkUserLogin() && loader ? (
        <PageLoader
          title="Fetching Trip Details"
          message="Please wait while we load your trip details."
        />
      ) : (
        <React.Fragment>
          <Helmet>
            <title>
              Cleartrip Customer Support & Contact Number | Connect with us on
              +91 9595333333
            </title>
            <meta
              name="title"
              content="Cleartrip Customer Support & Contact Number | Connect with us on +91 9595333333"
            />
            <meta
              name="description"
              content="Get in touch with Cleartrip customer care on +91 9595333333 for your queries. Or visit the page to get more information on your bookings."
            />
          </Helmet>
          <div
            style={{
              userSelect: 'auto',
              WebkitUserSelect: 'auto',
              display: visibilityCSS ? 'none' : ''
            }}
          >
            <DesktopHeader />
            <div
              className="secDesk"
              style={{ userSelect: 'auto', WebkitUserSelect: 'auto' }}
            >
              <div className="pt42" />
              <div
                className="secContent flex flex-between"
                style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
              >
                <div
                  className="w_100"
                  style={{ userSelect: 'auto', WebkitUserSelect: 'auto' }}
                >
                  <div
                    className=" px44"
                    style={{ userSelect: 'auto', WebkitUserSelect: 'auto' }}
                  >
                    <h1
                      className="f8 fBold c-neutral-900"
                      style={{ userSelect: 'auto', WebkitUserSelect: 'auto' }}
                    >
                      Welcome to Cleartrip Support
                    </h1>
                    <p className="pt2" />
                    <p
                      className="f4 lh24 c-neutral-700"
                      style={{ userSelect: 'auto', WebkitUserSelect: 'auto' }}
                    >
                      Find answers to all your queries, call us at +91
                      9595333333
                    </p>
                    <div className="pt30" />
                    <div className="flex">
                      <Flight fill="#AECFF9" width="29" />
                      <div className="pl28" />
                      <Hotel fill="#AECFF9" width="31" />
                      <div className="pl28" />
                      <Train fill="#AECFF9" width="19" />
                    </div>
                    <div className="pt42" />
                    <div className="pt10" />
                  </div>
                  <div
                    className="leftWidget ba bc-grey bg-white px40 py30"
                    style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                  >
                    <p
                      className="f5 fSemiBold lh28"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      Want to know about your bookings? Help us find your trips
                    </p>
                    <p
                      className="lh20 f3 c-neutral-700 "
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      {"Give us any traveller's Trip ID to check trip details"}
                    </p>
                    <div className="pt30" />
                    <div
                      className="flex flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <span
                        className="fSemiBold f3 c-neutral-900 inputLabel"
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        Trip ID
                      </span>
                      <div className="p-relative">
                        <input
                          className="inputBoxP ba bc-grey"
                          value={tripId || ''}
                          onChange={e => textHandler(e, 'tripId')}
                          placeholder="Enter Trip ID"
                          maxLength="15"
                          disabled={otpReceived}
                        />
                        <span
                          className="insideButton p-absolute c-pointer pad-2"
                          onClick={e => {
                            resetHandler(e)
                          }}
                        >
                          Change
                        </span>
                      </div>
                    </div>
                    <div className="pt-1" />
                    <div className="flex flex-middle">
                      <span className="fSemiBold f3 c-neutral-900 inputLabel" />
                      {invalidAccount && (
                        <div className="p-relative w-40p fs-12">
                          <p className="err errMsg lh-16">{deletedMsg}</p>
                        </div>
                      )}
                      {!otpReceived && otpReceivedErr && (
                        <div className="p-relative w-40p fs-12">
                          <p className={`${otpReceivedErr ? 'errMsg' : 'err'}`}>
                            {snackMsg}
                          </p>
                        </div>
                      )}
                    </div>

                    <div className={invalidAccount ? 'pt-4' : 'pt-5'} />
                    <div
                      className="flex flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <span
                        className="fSemiBold f3 c-neutral-900 inputLabel"
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        6 digit OTP
                      </span>
                      <div className="p-relative">
                        <input
                          className="inputBoxP ba bc-grey input_box_otp"
                          value={otp || ''}
                          onChange={e => textHandler(e, 'otp')}
                          maxLength="6"
                          // onKeyPress="return onlyNumberKey(event)"
                          type="text"
                          disabled={!otpReceived}
                          placeholder="Enter the OTP received"
                        />
                        <If condition={otpReceivedErr}>
                          <span
                            className="insideButton p-absolute"
                            onClick={e => btnHandler(e, 'Get OTP')}
                          />
                        </If>
                        <If condition={otpReceived}>
                          <span
                            id="timer"
                            className="insideButton p-absolute c-pointer"
                            onClick={e => btnHandler(e, 'Resend OTP')}
                          />
                        </If>
                      </div>
                      <div className="pl13" />
                      <button
                        type="submit"
                        className="submitButton pointer"
                        disabled={
                          tripId === null || (otpReceived && otp === null)
                        }
                        onClick={e => {
                          btnHandler(e, otpReceived ? 'Fetch Trip' : 'Get OTP')
                        }}
                      >
                        {otpReceived && !otpReceivedErr
                          ? 'Fetch Trip'
                          : 'Get OTP'}
                      </button>
                    </div>
                    <div className="pt10" />
                    <div className="flex flex-middle">
                      <span className="fSemiBold f3 c-neutral-900 inputLabel" />
                      {otpReceived && otpReceivedErr && (
                        <div className="p-relative w-40p fs-12">
                          <p className={`${otpReceivedErr ? 'errMsg' : 'err'}`}>
                            {snackMsg}
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="pt30" />
                    <div className="pt10" />
                    <p
                      className="c-neutral-700 f3"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      Have an account?{' '}
                      <span
                        className="c-pointer"
                        style={{ color: '#005FDB' }}
                        onClick={e => signHandle(e)}
                      >
                        Sign in
                      </span>{' '}
                      to fetch your trips
                    </p>
                  </div>
                  <div
                    className="leftWidget px40 py30"
                    style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                  >
                    <p
                      className="c-neutral-900 f7 fSemiBold"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      Frequently asked questions
                    </p>
                    <div className="pt10" />
                    <div className="pt10" />
                    <div style={{ userSelect: 'auto' }}>
                      <p
                        className="c-neutral-900 f4 fSemiBold"
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        Flight cancellation{' '}
                      </p>
                      <div className="pt10" />
                      <ul
                        className="c-secondary-500 f3 c-pointer"
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        <li>
                          <a
                            href="/faq/flights/index.shtml#cancel_booking"
                            target="_blank"
                            style={{
                              WebkitUserSelect: 'auto',
                              userSelect: 'auto'
                            }}
                          >
                            How do I cancel a flight ?
                          </a>
                        </li>
                        <li className="pt10" />
                        {/* <li>How do I only to cancel only a part of my booking?</li> */}
                      </ul>
                    </div>
                    <div className="pt10" />
                    <div className="pt10" />
                    <div
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <p
                        className="c-neutral-900 f4 fSemiBold"
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        Flight reschedule{' '}
                      </p>
                      <div className="pt10" />
                      <ul className="c-secondary-500 f3 c-pointer">
                        <li>
                          <a
                            href="faq/flights/"
                            target="_blank"
                            style={{
                              WebkitUserSelect: 'auto',
                              userSelect: 'auto'
                            }}
                          >
                            How do I make changes to flight reservation?
                          </a>
                        </li>
                        <li className="pt10" />
                      </ul>
                    </div>
                  </div>
                  <div className="dashedBorder px40" />
                  <div
                    className="leftWidget px40 py30"
                    style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                  >
                    <p
                      className="c-neutral-900 f4 fSemiBold"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      Hotel{' '}
                    </p>
                    <div className="pt10" />
                    <ul
                      className="c-secondary-500 f3 c-pointer"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <li>
                        <a
                          href="faq/hotels/"
                          target="_blank"
                          style={{
                            WebkitUserSelect: 'auto',
                            userSelect: 'auto'
                          }}
                        >
                          Click here for Hotel FAQ's
                        </a>
                      </li>
                      <li className="pt10" />
                      {/* <li><a href="faq/hotels/" target="_blank">I want to confirm my hotel booking status, how do I do that?</a></li>
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">What is my check in time at the hotel?</a></li>
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">What are the cancellation charges for a hotel booking?</a></li>
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">Help! My booking was denied by the hotel!</a></li>
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">I need to make a change to my hotel booking, how do I do that?</a></li>
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">I would like to make a special request for my booking, how can I do that?</a></li>
                <li className="pt10" />
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">Our children will be travelling with us - do they stay for free?</a></li>
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">Do I need to show ID proof when I check in at the hotel?</a></li>
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">My refund was initiated, but I haven't received it yet.</a></li>
                <li className="pt10" />
                <li><a href="faq/hotels/" target="_blank">I was unhappy with the hotel's service.</a></li> */}
                    </ul>
                  </div>
                  <div className="pt42" />
                  <div className="pt42" />
                  <div className="pt5" />
                </div>
                <div style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
                  <div
                    className="rightWidget ba bc-grey bg-white px16 py21 "
                    style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                  >
                    <p
                      className="f4 fSemiBold c-neutral-700"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      Fetch your trips to
                    </p>
                    <div className="pt10" />
                    <div className="pt10" />
                    <p
                      className="checkList flex flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <Tick fill="#339900" />
                      <div className="pl8" />
                      <span
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        Check your trip details
                      </span>
                    </p>
                    <div className="pt10" />
                    <p
                      className="checkList flex flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <Tick fill="#339900" />
                      <div className="pl8" />
                      <span>Cancel your trip</span>
                    </p>
                    <div className="pt10" />
                    <p
                      className="checkList flex flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <Tick fill="#339900" />
                      <div className="pl8" />
                      <span
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        Amend your flights
                      </span>
                    </p>
                    <div className="pt10" />
                    <p
                      className="checkList flex flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <Tick fill="#339900" />
                      <div className="pl8" />
                      <span
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        {' '}
                        Print E ticket
                      </span>
                    </p>
                    <div className="pt10" />
                    <p
                      className="checkList flex flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <Tick fill="#339900" />
                      <div className="pl8" />
                      <span
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        {' '}
                        and more…
                      </span>
                    </p>
                  </div>
                  <div className="pt10" />
                  <div className="pt10" />
                  <div
                    className="rightWidget ba bc-grey bg-white px16 py21 "
                    style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                  >
                    <p
                      className="f3 c-neutral-700 lh18"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      Plan your vacation and book hotels in over 15,000 hotels
                      worldwide
                    </p>
                    <div className="pt10" />
                    <div className="pt10" />
                    <img src={HotelBookImage} width="176" alt="" />
                    <div className="pt10" />
                    <div className="pt10" />
                    <div className="pt5" />
                  </div>
                </div>
              </div>
              <Footer />
              <If condition={page}>
                {showUnifiedLogin ? (
                  <ViewContainer
                    page={page}
                    isShowing={isShowing}
                    toggle={toggle}
                    handleIsShowing={handleIsShowing}
                    abLogin={abLogin}
                  />
                ) : (
                  <Login
                    page={page}
                    isShowing={isShowing}
                    toggle={toggle}
                    handleIsShowing={handleIsShowing}
                  />
                )}
              </If>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
export default SupportDesktop
